import {ApolloLink, Observable} from '@apollo/client';

import type {GraphQLError} from 'graphql';
import type {InternalOperation} from 'src/types';

export default function createKillswitchLink(): ApolloLink {
  const killswitchedOperations = new Set<string>();

  return new ApolloLink(function killswitchLink(
    operation: InternalOperation,
    forward,
  ) {
    if (killswitchedOperations.has(operation.operationName)) {
      return new Observable((observer) => {
        const error: GraphQLError = {
          message: 'Killswitched request',
          name: 'Killswitched request',
          path: [],
          extensions: {
            actionId: null,
            traceId: null,
            error: {
              code: 'killswitch_error',
              source: 'client',
              status: -1,
            },
            unstable_requestId: null,
          },
          nodes: undefined,
          source: undefined,
          positions: undefined,
          originalError: undefined,
          locations: undefined,
        };

        observer.next({
          data: null,
          errors: [error],
        });

        observer.complete();
      });
    }

    return new Observable(function killswitchObserver(observer) {
      const subscription = forward(operation).subscribe({
        next: function killswitchLinkNext(result) {
          const context = operation.getContext();
          const responses =
            context.responses ?? (context.response && [context.response]) ?? [];

          responses.forEach((response) => {
            const killswitchHeader = response?.headers?.get?.(
              'X-Request-Killswitch',
            );

            if (killswitchHeader) {
              const operationsToKillswitch = killswitchHeader
                .trim()
                .split(/\s*,\s*/);

              operationsToKillswitch.forEach((name: string) => {
                if (name) {
                  killswitchedOperations.add(name);
                }
              });
            }
          });

          return observer.next(result);
        },

        error: function killswitchLinkError(error) {
          return observer.error(error);
        },

        complete: function killswitchLinkComplete() {
          return observer.complete();
        },
      });

      return function killswitchLinkUnsubscribe(): void {
        if (subscription) {
          subscription.unsubscribe();
        }
      };
    });
  });
}
